export default __webpack_public_path__ + "static/media/ups.8459ccf5.jpg";